import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { Card, CardBody } from '../Card';
import { VStack } from '../VStack';
import { useListGroupContext } from './ListGroup.Context';

function ListGroupContent(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'ListGroupContent'),
      children = _useContextSystem.children,
      spacing = _useContextSystem.spacing,
      otherProps = _objectWithoutProperties(_useContextSystem, ["children", "spacing"]);

  var _useListGroupContext = useListGroupContext(),
      inset = _useListGroupContext.inset;

  if (!inset) return children;
  return /*#__PURE__*/React.createElement(Card, Object.assign({
    elevation: 0,
    isBorderless: true
  }, otherProps, {
    ref: forwardedRef
  }), /*#__PURE__*/React.createElement(CardBody, {
    scrollable: false
  }, /*#__PURE__*/React.createElement(VStack, {
    spacing: spacing
  }, children)));
}

export default contextConnect(ListGroupContent, 'ListGroupContent');